import { Box, FlexBox } from '@dixa/lib-shared-habla';
import { PropsWithChildren } from 'lib-shared-types-utils';

import { KeyboardKeyCombinations } from 'components/keyboard';
import { CommandName, useCommands } from 'utils/commands';
import { useAppSelector } from 'utils/redux/useAppSelector';

type CommandKeybindingsTooltipContentProps = PropsWithChildren & {
  /** The name of the command of which to show the keybindings of. */
  commandName: CommandName;
};

/**
 * Represents the components for displaying a tooltip content with associated
 * keybindings of a command.
 */
export const CommandKeybindingsTooltipContent = (
  props: CommandKeybindingsTooltipContentProps,
): JSX.Element => {
  const { keybindings } = useCommands();
  const keyboardShortcuts = useAppSelector(
    (state) => state.settings.personal.keyboardShortcuts,
  );
  const tooltipKeybindings = keybindings[props.commandName];

  const showKeybindings = keyboardShortcuts && tooltipKeybindings.length;

  return (
    <FlexBox alignItems="center" flexDirection="column" gap="200">
      {props.children}

      {showKeybindings && (
        <Box margin="0 0 100">
          <KeyboardKeyCombinations
            keyCombinations={tooltipKeybindings}
            variant="simple"
          />
        </Box>
      )}
    </FlexBox>
  );
};
